import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DatePicker, Select } from 'antd';
import I18n from 'i18n-js';
import styles from './styles.less';

const { RangePicker } = DatePicker;

const Filters = ({
  shop,
  metadata,
  onTimeRangeChange,
  onShippingTypeChange,
}) => {
  if (!metadata || !shop) {
    return null;
  }

  const earliestStartTime = metadata.earliestStartTime * 1000;
  const tomorrowTime = moment()
    .add(1, 'days')
    .valueOf();

  return (
    <div className={styles.filters}>
      <RangePicker
        className={styles.datePicker}
        placeholder={[
          I18n.t('shopify.orders.filters.startDatePlaceholder'),
          I18n.t('shopify.orders.filters.endDatePlaceholder'),
        ]}
        disabledDate={date =>
          date.valueOf() < earliestStartTime || date.valueOf() > tomorrowTime
        }
        allowClear
        onChange={onTimeRangeChange}
      />
      {metadata.shippingTypes && (
        <Select
          allowClear
          className={styles.shippingTypeSelect}
          placeholder={I18n.t('shopify.orders.filters.shippingTypePlaceholder')}
          onChange={onShippingTypeChange}
        >
          {metadata.shippingTypes.map(st => (
            <Select.Option key={st} value={st}>
              {st}
            </Select.Option>
          ))}
        </Select>
      )}
    </div>
  );
};

Filters.propTypes = {
  shop: PropTypes.shape({}).isRequired,
  metadata: PropTypes.shape({}).isRequired,
  onTimeRangeChange: PropTypes.func.isRequired,
  onShippingTypeChange: PropTypes.func.isRequired,
};

export default Filters;
